import { get } from 'lodash';
import { schema } from 'normalizr';

import { PayloadApiRequest } from '../actions/sagaApi';

import createResource from './createResource';
import offersResourceConfig from './offersResourceConfig';
import { EntityID, Offer } from './types';
import waitlistsResource from './waitlistsResource';

const offersResource = createResource<Offer>({
  ...offersResourceConfig,
  lookups: {
    ...offersResourceConfig.lookups,
    waitlists: {
      ...waitlistsResource,
      schema: new schema.Array(waitlistsResource.schema),
    },
  },
});

const customActions = {
  cancelOffer: (id: EntityID, payload?: PayloadApiRequest<Offer>) =>
    offersResource.request({
      url: `${offersResource.url}/${id}/cancel`,
      method: 'post',
      ...payload,
      meta: {
        schema: offersResource.schema,
        messageError: 'There was a problem canceling the offer. Please try again',
        ...get(payload, 'meta'),
      },
    }),
};

export default {
  ...offersResource,
  ...customActions,
};
